import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from "react";

/** Figma Icons/Tick — 17×13, fill Black 100 */
export function CheckboxTickIcon(t0) {
  const $ = _c(7);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path fillRule="evenodd" clipRule="evenodd" d="M16.0002 0.382152C16.6176 0.934543 16.6703 1.88283 16.1179 2.50021L7.62176 11.9959C7.00939 12.6803 5.93202 12.6615 5.344 11.9558L0.347706 5.96029C-0.18264 5.32388 -0.0966544 4.37803 0.539761 3.84768C1.17618 3.31734 2.12202 3.40332 2.65237 4.03974L6.54038 8.70535L13.8822 0.499822C14.4346 -0.117556 15.3829 -0.170239 16.0002 0.382152Z" fill="currentColor" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== className || $[5] !== props) {
    t2 = <svg xmlns="http://www.w3.org/2000/svg" className={className} width={17} height={13} viewBox="0 0 17 13" fill="none" aria-hidden="true" {...props}>{t1}</svg>;
    $[4] = className;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}

/** Centered minus for indeterminate (product extension) */
export function CheckboxMinusIcon(t0) {
  const $ = _c(7);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <rect width="12" height="2" rx="1" />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== className || $[5] !== props) {
    t2 = <svg className={className} viewBox="0 0 12 2" fill="currentColor" aria-hidden="true" {...props}>{t1}</svg>;
    $[4] = className;
    $[5] = props;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}